export const NEXT_PUBLIC_MAGENTO_BASE_URL = process.env.NEXT_PUBLIC_MAGENTO_BASE_URL;
export const NEXT_PUBLIC_PHARMACY_MED_AUTH_TOKEN = process.env.NEXT_PUBLIC_PHARMACY_MED_AUTH_TOKEN;

export const filterKeyForApi = {
  MaternityCare: "filter_contents-474606",
  MotherhoodStage: "filter_contents-474605",
};
